import React from "react";
import github_img from "./images/github.png";
import resume_img from "./images/resume.png";
import email_img from "./images/email.png";
import linkedin_img from "./images/linkedin.png";
import profile_img from "./images/tarun_1.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "./intro.css";

const IntroPage = () => {
  const changeView = () => {
    window.open("/data-science-journey/", "_blank");
  };
  return (
    <div>
      <div className="intro_page" id="intro_page">
        <div className="brief">
          <div className="intro_text">
            <div className="myname">
              <h1 className="typewriter">Hi, I'm Tarun Garg</h1>
              <br></br>
              <h2 className="typewriter">Senior Data Scientist @ Zomato</h2>
            </div>
            <div className="about_me fade-in-left-to-right">
              <p>
                I'm currently heading the Data Science vertical for Zomato's
                Marketing team, building high-impact ML solutions that drive
                business value. With 6+ years of experience in machine learning,
                logistics optimization, fraud detection, and growth analytics, I
                specialize in translating complex data challenges into scalable,
                production-ready solutions. My expertise spans predictive
                modeling, geospatial analytics, user segmentation, and
                marketing optimization—from pLTV models for Google Ads to rider
                logistics optimization. I'm passionate about creating insights
                that directly impact outcomes across Zomato, Ecom Express,
                Cars24, and Walmart Labs.
              </p>
              <br></br>
              <button className="blog_url" onClick={changeView}>
                <b>
                  {" "}
                  <i>📊 Explore My Data Science Journey</i>{" "}
                </b>
              </button>
            </div>
            <div className="icon">
              <a
                href="https://drive.google.com/file/d/1KZuAwK3G_uOe_JY8quUhza_rsdpc9j3r/"
                target="_blank"
                title="Resume"
              >
                <img src={resume_img} alt="Resume"></img>
              </a>
              <a
                href="https://github.com/Tarungarg98"
                target="_blank"
                title="Github"
              >
                <img src={github_img} alt="Github"></img>
              </a>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=gargtarun13@gmail.com"
                title="Mail"
                target="_blank"
              >
                <img src={email_img} alt="Mail"></img>
              </a>
              <a
                href="https://www.linkedin.com/in/tarungarg98/"
                title="LinkedIn"
                target="_blank"
              >
                <img src={linkedin_img} alt="Linkedin"></img>
              </a>
            </div>
          </div>

          <div className="profile_image_container">
            <img src={profile_img} alt="Tarun Garg" className="profile_image" />
          </div>
        </div>
      </div>
      <br></br>
    </div>
  );
};

export default IntroPage;
